export default Object.freeze({
  PERSON: 'person',
  ASSOCIATION: 'association',
  BOTH: 'both'
})



// WEBPACK FOOTER //
// ./src/enums/delegate-type.js